import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { injectIntl } from 'react-intl'
import useGetConfigurator from 'core/hooks/useGetConfigurator'
import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import wizardsShape from 'core/components/wizard/shapes'
import { Row, Col, Empty, Spin } from 'core/components/ui'
import TitleIcon from 'core/layouts/title-icon'
import { configuratorShape } from '../shapes'
import TypeColor from './type-color'
import Color from './color'
import Interior from './interior'

const StyledTitleIcon = styled(TitleIcon)`
  margin-bottom: 25px;
`

const Design = props => {
  const { setWizards, wizards, history, setConfigurator, configurator, intl } = props

  const { loading, designs, getDesign } = useGetConfigurator({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })

  const { designList, brand, model, design, motor } = configurator

  const { interior, exterior } = design

  const aStepsActive = wizards[wizards.activeWizard]

  const desactivateNextStep = () => {
    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_DESIGN) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: false }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)
  }

  const activateNextStep = () => {
    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_DESIGN) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)
  }

  const displayColors = () =>
    designList.exterior && designList.exterior.color.length > 0 ? (
      designList.exterior.color.map(item => (
        <Color data-test="configurator-design-color" item={item} key={item.label} />
      ))
    ) : (
      <Row type="flex" style={{ width: '100%' }} justify="center" align="middle">
        <Empty />
      </Row>
    )

  const Colors = () => (
    <Row type="flex" gutter={30} justify={loading ? 'center' : 'start'}>
      {loading ? <Spin /> : displayColors()}
    </Row>
  )

  useEffect(() => {
    const { type, color } = exterior

    if (interior !== null && type !== null && color !== null) {
      activateNextStep()
    }
  }, [design])

  useEffect(() => {
    const runIt = list => {
      const serialLeathers = list.interior.leathers.filter(item => item.serial)
      const serialFabrics = list.interior.fabrics.filter(item => item.serial)
      const serialInteriors = serialLeathers.concat(serialFabrics)

      const serialPaints = _.first(list.exterior.type.filter(item => item.serial))
      const extendedExterior = { ...exterior, type: serialPaints }
      const extendedDesign = { ...design, interior: serialInteriors, exterior: extendedExterior }

      setConfigurator({
        ...configurator,
        designList: list,
        design: extendedDesign
      })
    }

    if (designs) runIt(designs)
  }, [designs])

  useEffect(() => {
    // Redirection if direct access & step is not active

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.CONFIGURATOR_DESIGN
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    if (!design.exterior.type && !design.exterior.color && !design.exterior.interior)
      desactivateNextStep()

    const params = {
      id: motor.id,
      brand: brand.id,
      model: model.id,
      catalog: motor.catalog
    }

    getDesign(params)
  }, [])

  return (
    <MainContentWrapper
      title={intl.formatMessage({ id: 'configurator-design-view-title' })}
      data-test="component-configurator-design"
    >
      <StyledTitleIcon
        title={intl.formatMessage({
          id: 'configurator-design-card-1-title'
        })}
      />
      <Row gutter={60}>
        <Col lg={12} xs={24}>
          {isMobile ? <Colors /> : <TypeColor loading={loading} />}
        </Col>
        <Col lg={12} xs={24}>
          {isMobile ? <TypeColor loading={loading} /> : <Colors />}
        </Col>
      </Row>
      <StyledTitleIcon
        title={intl.formatMessage({
          id: 'configurator-design-card-2-title'
        })}
      />
      <Row>
        <Col>
          <Interior data-test="configurator-design-interior" loading={loading} />
        </Col>
      </Row>
    </MainContentWrapper>
  )
}

Design.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  intl: PropTypes.shape().isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default withRouter(injectIntl(Design))
